import lodashHas from "lodash/has";

import POLITICAL_CATEGORIES from "../../common/constants/controlRisks/IncidentsPoliticalCategories.js";
import MARITIME_CATEGORIES from "../../common/constants/controlRisks/IncidentsMaritimeCategories.js";
import GenericPoliticalMapMarker from "../../assets/images/icons/controlRisksIncidents/security/map/Generic.svg";
import GenericMaritimeMapMarker from "../../assets/images/icons/controlRisksIncidents/maritime/map/Generic.svg";
import { getArticles } from "@/services/search/wod.service";

export { _getIncidents as getIncidents };
export { _getCategoryIcon as getCategoryIcon };
export { _loadCategoryIcons as loadCategoryIcons };

const ICON_PREFIX = "cr_incidents_";
const GENERIC_POLITICAL_ICON_ID = ICON_PREFIX + "_political_generic";
const GENERIC_MARITIME_ICON_ID = ICON_PREFIX + "_maritime_generic";

const _getIncidents = async (params) => {
  try {
    params.sources = params.maritimeEnabled ? "maritime" : "political";
    params.eventType = "verified";
    params.verifiedType = params.maritimeEnabled ? "maritime" : "security";

    const incidents = await getArticles(params);

    return incidents;
  } catch (error) {
    Promise.reject(
      "Issue getting incidents in incidents.service.js: " +
        JSON.stringify(error)
    );
    return null;
  }
};

const _getCategoryIdByName = (name, isMaritime) => {
  let checkList = isMaritime ? MARITIME_CATEGORIES : POLITICAL_CATEGORIES;
  for (let i = 0; i < checkList.length; i++) {
    if (checkList[i].Name === name) {
      return checkList[i].Id;
    }
  }
};

const _getIconNameFromIncident = (incident, isMaritime) => {
  if (lodashHas(incident, "Categories[0]")) {
    return (
      ICON_PREFIX + _getCategoryIdByName(incident.Categories[0], isMaritime)
    );
  }
  if (lodashHas(incident, "Category")) {
    return ICON_PREFIX + _getCategoryIdByName(incident.Category, isMartiime);
  }
  return isMaritime ? GENERIC_MARITIME_ICON_ID : GENERIC_POLITICAL_ICON_ID;
};

const _getCategoryIcon = (categoryId, kind) => {
  kind = kind ? kind : "Big";
  for (let i = 0; i < POLITICAL_CATEGORIES.length; i++) {
    if (categoryId === POLITICAL_CATEGORIES[i].Id) {
      return POLITICAL_CATEGORIES[i].Icons[kind];
    }
  }
  for (let i = 0; i < MARITIME_CATEGORIES.length; i++) {
    if (categoryId === MARITIME_CATEGORIES[i].Id) {
      return MARITIME_CATEGORIES[i].Icons[kind];
    }
  }
};

const _loadMapIcon = (map, id, src) => {
  let img = new Image();
  img.onload = () => {
    map.addImage(id, img);
  };
  img.src = src;
};

const _loadCategoryIcons = (map) => {
  for (let i = 0; i < POLITICAL_CATEGORIES.length; i++) {
    _loadMapIcon(
      map,
      ICON_PREFIX + POLITICAL_CATEGORIES[i].Id,
      POLITICAL_CATEGORIES[i].Icons.Map
    );
  }
  _loadMapIcon(map, GENERIC_POLITICAL_ICON_ID, GenericPoliticalMapMarker);
  for (let i = 0; i < MARITIME_CATEGORIES.length; i++) {
    _loadMapIcon(
      map,
      ICON_PREFIX + MARITIME_CATEGORIES[i].Id,
      MARITIME_CATEGORIES[i].Icons.Map
    );
  }
  _loadMapIcon(map, GENERIC_MARITIME_ICON_ID, GenericMaritimeMapMarker);
};
